export default __webpack_public_path__ + "media/Exercise.6c1dffb8.svg";